import {inject, injectable} from "inversify";
import {Team} from "@/modules/team/entity";
import NotificationCreator from "@/modules/youth/notifications/NotificationCreator";
import {Notifier} from "@/modules/notifications/services/Notifier";
import YouthPlayerFactory from "@/modules/youth/services/factories/YouthPlayerFactory";
import chance from "@/modules/base/services/chance";
import {Region} from "@/modules/base/entity";

@injectable()
export class NotificationFactory {
  constructor(
    @inject(NotificationCreator) private notificationCreator: NotificationCreator,
    @inject(Notifier) private notifier: Notifier,
    @inject(YouthPlayerFactory) private youthPlayerFactory: YouthPlayerFactory,
  ) {}

  public async generate(team: Team, count = 1) {
    await team.load('youthPlayers');

    const region = await Region
      .createQueryBuilder('region')
      .orderBy('RANDOM()')
      .getOneOrFail();

    const players = await this.youthPlayerFactory.generate(region, count, player => {
      player.revelation = 100;
      player.team = team;
    });

    for (let i = 1; i < count; i++) {
      await this.notifier.notify(
        await this.notificationCreator.createScoutingComplete(chance.pickone(players))
      );

      console.debug(`Generate notification`);
    }
  }
}